import React from "react"
import "../../styles/HeaderLink.css"

const HeaderLink = ({text="", link="/"}) => (

    <div className="header-divider">
        <div className="header-container">
            <div className="header-square">
                <div className="hex-frame">
                    <div className="hexagonal-aspect-ratio" />
                    <div className="hex-container">
                        <div className="hex">
                            <div className="hex-corner-1" />
                            <div className="hex-corner-2" />
                            <div className="hex-inner">

                                <div className="header-link">
                                    <a href={link}>
                                    {text}
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


)

export default HeaderLink
